import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MonthlyReportComp from "../MonthlyReportComp";
import { Table } from "react-bootstrap";
import Select from "react-select";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import { monthlyReportHandler } from "../store/monthlyReportSlice";
import { FaSpinner } from "react-icons/fa";
import { alignPropType } from "react-bootstrap/esm/types";

const MonthlyReportList = () => {
  const dispatch = useDispatch();

  const [MonthlyCompOff, setMonthlyCompOff] = useState([]);
  const [MonthlyLeave, setMonthlyLeave] = useState([]);
  const [MonthlyReport, setMonthlyReport] = useState([]);
  const [MonthlyPayrollReport, setMonthlyPayrollReport] = useState([]);
  const [MonthList, setMonthList] = useState([]);
  const [EmployeList, setEmployeeList] = useState([]);
  const [IncentiveCCA, setIncentiveCCA] = useState([]);
  const [Tne, setTne] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState();

  const [selectedEmployee, setSelectedEmployee] = useState();
  // demo code
  const [Profiles, setProfiles] = useState([]);

  useEffect(() => {
    fetchGetIndexData();
  }, []);

  const fetchGetIndexData = async () => {
    try {
      let response;
      response = await GetServiceCaller(`${API_URL}get-months-employees`);

      if (response?.status === 200) {
        const cleanedData = response?.data;

        const monOpt = cleanedData?.calendermonth?.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setMonthList(monOpt);
        fetchGetData(monOpt[0]?.value);
        setSelectedMonth(monOpt[0]?.value);
        const employees = cleanedData?.employeelist?.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setEmployeeList(employees);
      }
    } catch (error) {
      console.error("Fetching Error ", error);
    }
  };

  const [apiStatus, setApiStatus] = useState("");

  const fetchGetData = async (selectedMonth, selectedEmployee) => {
    setApiStatus(undefined);
    try {
      let response;
      response = await GetServiceCaller(
        `${API_URL}org-report/3?P_MonthID=${selectedMonth || 0}&P_EmployeeID=${
          selectedEmployee || ""
        }&P_ApplicationStatus=`
      );

      if (response?.status === 200) {
        setApiStatus(response?.status);
        const cleanedData = response?.data;
        setIncentiveCCA(cleanedData?.monthlyIcca);
        setTne(
          cleanedData?.monthlyTne?.map((item) => ({
            ...item,
            TotalExpense: Number(item?.TotalExpense).toFixed(2),
          }))
        );
        setMonthlyCompOff(cleanedData?.monthlyCompoff);
        setMonthlyLeave(cleanedData?.monthlyLeave);
        setMonthlyReport(cleanedData?.monthlyNewJoinee);
        setMonthlyPayrollReport(cleanedData?.monthlyPayroll);
      }
    } catch (error) {
      console.error("Fetching Error ", error);
    }
  };

  // comp Off column
  const CompOffColumn = {
    EmployeeName: { text: "Employee", align: "start" },
    ProjectName: { text: "Project", align: "start" },
    FromDate: { text: "From", align: "center" },
    ToDate: { text: "To", align: "center" },
    ApplicationStatus: { text: "Status", align: "start" },
    ActionByName: { text: "Action By", align: "start" },
  };
  const CompDefaultColumns = {
    EmployeeName: true,
    ProjectName: true,
    FromDate: true,
    ToDate: true,
    ApplicationStatus: true,
    ActionByName: true,
  };

  // Incentive and CCA column
  const IncentiveColumn = {
    Type: { text: "Type", align: "start" },
    Employee: { text: "Employee", align: "start" },
    Project: { text: "Project", align: "start" },
    City: { text: "City", align: "start" },
    Amount: { text: "Amount", align: "end" },
    PayrollMonth: { text: "Month" },
    ApplicationStatus: { text: "Status", align: "start" },
  };
  const IncentiveDefaultColumns = {
    Type: true,
    Employee: true,
    Project: true,
    City: true,
    Amount: true,
    PayrollMonth: true,
    ApplicationStatus: true,
  };

  // TNE Column
  const TNEColumn = {
    Name: { text: "Employee", align: "start" },
    ProjectName: { text: "Project", align: "start" },
    SuperiorName: { text: "Manager", align: "start" },
    FromDate: { text: "From", align: "center" },
    ToDate: { text: "To", align: "center" },
    AdvanceAmountBASE: { text: "Adv Amt.", align: "end" },
    TotalExpense: { text: "Total Expense", align: "end" },
    ApprovedAmountBASE: { text: "Approved Amt.", align: "end" },
    BalanceAmountBASE: { text: "Balance Amt.", align: "end" },
    Status: { text: "Status", align: "center" },
    PayrollMonth: { text: "Payroll Month", align: "center" },
  };
  const TNEDefaultColumns = {
    Name: true,
    ProjectName: true,
    SuperiorName: true,
    FromDate: true,
    ToDate: true,
    AdvanceAmountBASE: true,
    TotalExpense: true,
    ApprovedAmountBASE: true,
    BalanceAmountBASE: true,
    Status: true,
    PayrollMonth: true,
  };
  // Leave report column
  const LeaveColumn = {
    EmployeeName: { text: "Employee", align: "start" },
    FromDate: { text: "From", align: "center" },
    ToDate: { text: "To", align: "center" },
    ApplicationStatus: { text: "Status", align: "start" },
    ActionByName: { text: "Action By", align: "start" },
    ActionDate: { text: "Action Date", align: "center" },
  };

  const LeaveDefaultColumns = {
    EmployeeName: true,
    FromDate: true,
    ToDate: true,
    ApplicationStatus: true,
    ActionByName: true,
    ActionDate: true,
  };

  // New Joinee Column
  const columns = {
    ContactName: { text: "Employee", align: "start" },
    JoiningDate: { text: "Joining", align: "center" },
    Designation: { text: "Designation", align: "start" },
    MobileNo1: { text: "Contact No.", align: "center" },
  };
  const defaultColumns = {
    ContactName: true,
    JoiningDate: true,
    Designation: true,
    MobileNo1: true,
  };
  const handleGetData = (e) => {
    e.preventDefault();
    fetchGetData(selectedMonth, selectedEmployee);
  };

  const tneTotals = [
    "AdvanceAmountBASE",
    "TotalExpense",
    "ApprovedAmountBASE",
    "BalanceAmountBASE",
  ];


const PayrollColumnNames = {
  "Basic & DA": "Basic & DA",
  "HRA": "HRA",
  "Professional Development Allowance": "PDA", // Special Allow.
  "Conv Allow": "Conv. Allow",
  "Leave Travel Allowance": "LTA",
  "Gross Salary": "Gross Salary",
  "PT": "PT",
  "TDS": "TDS",
  "Provident Fund": "PF",
  "Net Salary": "Net Salary",
  "TotalCTC": "Total CTC"
};

  return (
    <>
      <div className="container-fluid" id="monthlyReport-area">
        {/* Filter Section */}
        <div className="row">
          <form onSubmit={handleGetData}>
            <div className="row p-2">
              <div className="d-flex gap-3">
                <div className="d-flex col-md-3">
                  <label className="form-label mt-1 me-1">Month</label>
                  <Select
                    options={MonthList}
                    value={MonthList?.find((o) => o.value === selectedMonth)}
                    className="col-8"
                    onChange={(selectedOption) =>
                      setSelectedMonth(selectedOption.value)
                    }
                  />
                </div>
                <div className="d-flex col-md-3">
                  <label className="form-label mt-1 me-1">Employee</label>
                  <Select
                    options={EmployeList}
                    className="col-8"
                    onChange={(selectedOption) =>
                      setSelectedEmployee(selectedOption.value)
                    }
                  />
                </div>
                <div className="d-flex col-md-3">
                  <button type="submit" className="custom-btn">
                    Get Data
                  </button>
                </div>
              </div>
            </div>
          </form>

     {apiStatus === 200 ? (
  <div style={{ fontSize: '0.85rem' }}>
    {/* Profile Section */}
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px', margin: '0 -5px' }}>
      {Profiles?.map((profile) => (
        <div
          key={profile.ID}
          style={{
            border: '1px solid #ddd',
            margin: '5px',
            padding: '5px',
            borderRadius: '4px',
            textAlign: 'center',
            flex: '0 0 auto'
          }}
        >
          <p style={{ margin: '0 0 3px 0', fontSize: '0.8rem' }}>Joined: {profile.JoiningDate}</p>
          <img
            src={profile.ProfileImage}
            alt={profile.ContactName}
            style={{
              width: '80px',
              height: '80px',
              borderRadius: '50%',
              objectFit: 'cover',
              marginTop: '3px'
            }}
            onError={(e) => {
              e.target.src = "default-profile.png";
            }}
          />
        </div>
      ))}
    </div>

    {/* Main Content */}
    <div style={{ marginTop: '10px' }}>
      {/* Payroll Section */}
      <div style={{ marginBottom: '10px' }}>
        <div style={{
          padding: '8px',
          border: '1px solid #eee',
          borderRadius: '4px'
        }}>
          <h6 style={{ margin: '0 0 5px 0', paddingBottom: '3px', borderBottom: '1px solid #eee', fontSize: '1rem' }}>
            <strong>Payroll</strong>
          </h6>
          <div style={{ overflowX: 'auto' }}>
            <table style={{
              width: '100%',
              borderCollapse: 'collapse',
              fontSize: '0.8rem',
              textAlign: 'center'
            }}>
              <thead style={{ backgroundColor: '#27568B', color:'#fff' }}>
                <tr>
                  <th style={{ padding: '4px 8px', border: '1px solid #dee2e6' }}>Month</th>
                  {MonthlyPayrollReport?.length > 0 ? (
                    MonthlyPayrollReport.map((item, index) => (
                      <th key={index} style={{ padding: '4px 8px', border: '1px solid #dee2e6' }}>
                        {item.ReportColumn}
                      </th>
                    ))
                  ) : (
                    <th style={{ padding: '4px 8px', border: '1px solid #dee2e6' }}>Total CTC</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {MonthlyPayrollReport?.length > 0 ? (
                  <tr>
                    <td style={{ padding: '4px 8px', border: '1px solid #dee2e6' }}>
                      {MonthlyPayrollReport[0]?.PayrollMonth || "-"}
                    </td>
                    {MonthlyPayrollReport.map((item, index) => (
                      <td key={index} style={{ padding: '4px 8px', border: '1px solid #dee2e6', textAlign: 'right' }}>
                        {Number(item.NetAmount).toFixed(2) || "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  <tr>
                    <td 
                      colSpan={MonthlyPayrollReport.length ? MonthlyPayrollReport.length + 1 : 2}
                      style={{ padding: '4px 8px', border: '1px solid #dee2e6', color: '#6c757d' }}
                    >
                      No Data
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Two Column Sections */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '10px' }}>
        
        {/* Comp-Off */}
        <div style={{ flex: '1 1 48%', minWidth: '300px' }}>
          <div style={{
            padding: '8px',
            border: '1px solid #eee',
            borderRadius: '4px',
            height: '100%'
          }}>
            <h6 style={{ margin: '0 0 5px 0', paddingBottom: '3px', borderBottom: '1px solid #eee', fontSize: '1rem', }}>
              <strong>Comp-Off</strong>
            </h6>
            <div>
              {MonthlyCompOff?.length > 0 ? (
                <MonthlyReportComp
                  data={MonthlyCompOff}
                  columns={CompOffColumn}
                  defaultColumns={CompDefaultColumns}
                  itemsPerPage={4}
                  style={{ fontSize: '0.8rem' }}
                />
              ) : (
                <div style={{ textAlign: 'center', padding: '10px 0', color: '#6c757d', fontSize: '0.8rem' }}>
                  No Data
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Leave */}
        <div style={{ flex: '1 1 48%', minWidth: '300px' }}>
          <div style={{
            padding: '8px',
            border: '1px solid #eee',
            borderRadius: '4px',
            height: '100%'
          }}>
            <h5 style={{ margin: '0 0 5px 0', paddingBottom: '3px', borderBottom: '1px solid #eee', fontSize: '1rem' }}>
              <strong>Leave</strong>
            </h5>
            <div>
              {MonthlyLeave?.length > 0 ? (
                <MonthlyReportComp
                  data={MonthlyLeave}
                  columns={LeaveColumn}
                  defaultColumns={LeaveDefaultColumns}
                  itemsPerPage={4}
                  style={{ fontSize: '0.8rem' }}
                />
              ) : (
                <div style={{ textAlign: 'center', padding: '10px 0', color: '#6c757d', fontSize: '0.8rem' }}>
                  No Data
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Another Two Column Sections */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '10px' }}>
        
        {/* Incentive/CCA */}
        <div style={{ flex: '1 1 48%', minWidth: '300px' }}>
          <div style={{
            padding: '8px',
            border: '1px solid #eee',
            borderRadius: '4px',
            height: '100%'
          }}>
            <h6 style={{ margin: '0 0 5px 0', paddingBottom: '3px', borderBottom: '1px solid #eee', fontSize: '1rem' }}>
              <strong>Incentive/CCA</strong>
            </h6>
            <div>
              {IncentiveCCA?.length > 0 ? (
                <MonthlyReportComp
                  data={IncentiveCCA}
                  columns={IncentiveColumn}
                  defaultColumns={IncentiveDefaultColumns}
                  itemsPerPage={4}
                  style={{ fontSize: '0.8rem' }}
                />
              ) : (
                <div style={{ textAlign: 'center', padding: '10px 0', color: '#6c757d', fontSize: '0.8rem' }}>
                  No Data
                </div>
              )}
            </div>
          </div>
        </div>

        {/* New Joinee */}
        <div style={{ flex: '1 1 48%', minWidth: '300px' }}>
          <div style={{
            padding: '8px',
            border: '1px solid #eee',
            borderRadius: '4px',
            height: '100%'
          }}>
            <h6 style={{ margin: '0 0 5px 0', paddingBottom: '3px', borderBottom: '1px solid #eee', fontSize: '1rem' }}>
              <strong>New Joinees</strong>
            </h6>
            <div>
              {MonthlyReport?.length > 0 ? (
                <MonthlyReportComp
                  data={MonthlyReport}
                  columns={columns}
                  defaultColumns={defaultColumns}
                  itemsPerPage={4}
                  style={{ fontSize: '0.8rem' }}
                />
              ) : (
                <div style={{ textAlign: 'center', padding: '10px 0', color: '#6c757d', fontSize: '0.8rem' }}>
                  No Data
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* TNE Section */}
      <div style={{ marginBottom: '10px' }}>
        <div style={{
          padding: '8px',
          border: '1px solid #eee',
          borderRadius: '4px'
        }}>
          <h6 style={{ margin: '0 0 5px 0', paddingBottom: '3px', borderBottom: '1px solid #eee', fontSize: '1rem' }}>
            <strong>TNE</strong>
          </h6>
          <div>
            {Tne?.length > 0 ? (
              <MonthlyReportComp
                data={Tne}
                columns={TNEColumn}
                defaultColumns={TNEDefaultColumns}
                itemsPerPage={4}
                tneTotals={tneTotals}
                style={{ fontSize: '0.8rem' }}
              />
            ) : (
              <div style={{ textAlign: 'center', padding: '10px 0', color: '#6c757d', fontSize: '0.8rem' }}>
                No Data
              </div>
            )}
          </div>
        </div>
      </div>

    </div>
  </div>
) : (
  // Loading State
  <div style={{
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '200px',
    fontSize: '0.9rem'
  }}>
    <FaSpinner style={{
      fontSize: '1.5rem',
      animation: 'spin 1s linear infinite',
      marginBottom: '8px'
    }} />
    <p>Loading</p>
  </div>
)}
        </div>
        <div></div>
      </div>
    </>
  );
};

export default MonthlyReportList;
